<template>

  <t-form-list :generalErrors="generalErrors" :items="items" :fields="fields" :command="command" :user-auth="userAuth"
               :status="status"
               :busy="!pageFormIsLoaded" :busy-form="!listFormIsLoaded" :busy-list="!listIsLoaded"
               primary-key-column="stockPlaceMoldInsideId" :foreign-key="foreignKey"
               :foreign-key-column="foreignKeyColumn"
               @onSubmit="onSubmit" @onItemRead="onItemReadDefault" @onItemDelete="onItemDeleteDefault">

    <t-input v-model="form.stockPlaceMoldInsideId" hidden/>

    <b-col cols="12" class="mb-2">

      <b-row>

        <b-col xl="9">

          <b-row>

            <t-input cols="6" v-model="form.name"  :add-error="error.name" label="Localização"
                     required/>
            <t-input cols="6" v-model="form.note" label="Observação"/>

          </b-row>

        </b-col>

        <b-col xl="3" class="button-form-inline">

          <t-button :sending="status === 'sending'" :text="onButtonSubmitText(command)" no-icon submit/>

          <b-link class="ml-2 text-focus" v-if="command === 'update'" @click="cancelUpdatedList()">
            {{ t('go-back') }}
          </b-link>

        </b-col>

      </b-row>

    </b-col>

  </t-form-list>

</template>
<script>
import pageDefaultMixin from "@/mixins/page/pageDefaultMixin"
import pageFormMixin from "@/mixins/page/pageFormMixin"
import pageFormListMixin from "@/mixins/page/pageFormListMixin"
import tFormList from "@/components/template/form/list/t-form-list"

export default {
  mixins: [pageDefaultMixin, pageFormMixin, pageFormListMixin],
  components: {tFormList},
  name: 'StockPlaceMoldLocation',
  data() {
    return {
      path: "stock/place-mold-inside", //Utilizar somente quando fora do padrão
      foreignKeyColumn: "stockPlaceMoldId", //Utilizar quando usar Tabs com outros componentes
      fields: [
        {keyRead: "stockPlaceMoldInsideId", keyDelete: "stockPlaceMoldInsideId"},
        {key: "name", label: "Localização", cols: "6"},
        {key: "note", label: "Observação", cols: "2"},
      ],
      form: {
        stockPlaceMoldInsideId: 0,
        stockPlaceMoldId: this.foreignKey,
        name: "",
        note: "",
        status: 1,
      },
      error: {//Campos que podem receber retorno de erro do backend
        name: "",
      },
      fieldsNotReset: [//Marca os nomes de colunas que não devem ser resetados
        this.foreignKeyColumn,
      ],
      //--------------------------------------------------------------------------------------
      //Início de campos personalizados desta tela


      //--------------------------------------------------------------------------------------
    }
  },
  methods: {

    defaultForm() {

      //Preenche somente os campos que foram limpos após o reset
      this.defaultFormList()


    },

    mountedPrepare() {

      this.mountedPrepareFormListDefault()

    },

    async mountedContinued() {

      await this.getList()

    },

    async onSubmit() {

      await this.setSendingFormListDefault(this.form.stockPlaceMoldInsideId)

    },

    mountedList() {

      // Manipulação da listagem após carregando
      //--------------------------------------
      /*let newItems = []

      for (let item of this.items) {

        newItems.push(item)

      }

      this.items = newItems*/
      //--------------------------------------

      this.listIsLoaded = true

    },
    //--------------------------------------------------------------------------------------
    //Início de métodos personalizados desta tela


    //--------------------------------------------------------------------------------------
  },
  async mounted() {

    this.mountedPrepare()

    await this.mountedFormList()

    await this.mountedContinued()

  },
}
</script>
